<script setup lang="ts">
const props = defineProps<{
  class?: string;
  link?: boolean;
  style?: string | Record<string, string | number>;
  disabled?: boolean;
  disableFocus?: boolean;
}>();
</script>

<template>
  <button
    :disabled="props.disabled"
    :style="props.style"
    :class="[
      props.link
        ? 'hover:text-slate-300 text-slate-400'
        : 'inline-flex items-center px-4 py-2 bg-sybil-teal border border-transparent font-semibold text-xs text-white uppercase tracking-widest hover:opacity-80  transition',
      props.class,
      props.disabled
        ? 'opacity-50 cursor-not-allowed'
        : props.disableFocus
        ? ''
        : 'focus:border-sybil-teal focus:ring focus:ring-sybil-teal focus:outline-none active:bg-sybil-teal',
    ]"
  >
    <slot />
  </button>
</template>
